export default "__VITE_ASSET__c4b70864__"